export default __webpack_public_path__ + "../staticImages/korkenzieher-260.png";